/*
 * author: wendux
 * email: 824783146@qq.com
 * source code: https://github.com/wendux/Ajax-hook
 */

import { hook } from "./xhr-hook";

export var ah = { hook };



// WEBPACK FOOTER //
// ./src/cdn-core.js